<template>
  <div class="indextop">
    <img class="banner" src="../../assets/images/ml-indexbg.jpg" v-if="$store.state.domainIndex==2&&bannerList.length==0">
    <img class="banner" src="../../assets/images/indexbg.jpg" v-if="$store.state.domainIndex!=2&&bannerList.length==0">
    <!-- <img class="banner" src="../../assets/images/indexbg.jpg"> -->
    <swiper :options="swiperOption" class="bannerlist" v-if="bannerList.length>0">
      <swiper-slide v-for="(item,index) in bannerList" :key="index">
        <a target="_blank" :href="item.imageUrl"><img v-lazy="item.imageSrc" /></a>
      </swiper-slide>
    </swiper>
    <div class="searchbox">
      <i class="m-icon mi-search"></i>
      <input class="sinput" type="text" placeholder="请输入楼盘名称或区域" @focus="$router.push({path:'/search'})">
      <!-- <el-dropdown class="slocal" trigger="click" v-if="storage.get('city')"> -->
        <span class="slocal" @click="showCity=true"><i class="m-icon mi-sltcity"></i>{{storage.get('city').city}}</span>
        <!-- <el-dropdown-menu slot="dropdown">
          <el-dropdown-item :key="index" v-for="(item,index) in cityItems" @click.native="changeCity(item)">{{item.city}}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown> -->
    </div>
    <div class="navbox">
      <ul>
        <li @click="$router.push({path:'/estate'})"><i class="m-icon mi-qblp"></i>全部楼盘</li>
        <li @click="$router.push({path:'/recommendList'})"><i class="m-icon mi-zslp discount"></i>新盘热推</li>
        <li @click="$router.push({path:'/findHouse'})"><i class="m-icon mi-bwzf new"></i>帮我找房</li>
        <li @click="$router.push({path:'/calculate'})"><i class="m-icon mi-fdjs"></i>房贷计算</li>
      </ul>
    </div>

    <div class="citywrap" id="citywrap" v-show="showCity">
      <p class="title" @click="showCityResult=false">选择城市<span class="closeicon" @click="showCity=false">×</span></p>
      <div class="search-city"><i class="m-icon mi-search"></i><input type="text" v-model="cityKey" placeholder="输入城市名或简称" @input="cityKeyChange" @focus="cityKey!=''?showCityResult=true:''">
        <div class="search-list" v-show="showCityResult">
          <span v-show="showTips">抱歉，没有找到相关城市</span>
          <p :key="index" v-for="(item,index) in searchCityList" @click="changeCity(item)">{{item.city}}</p>
        </div>
      </div>
      <div class="initials" :style="'margin-top:-'+cityItems.length*11+'px'">
        <span :key="indexs" v-for="(items,indexs) in cityItems" @click="letterClick('#' + items.letter)">{{items.letter}}</span>
      </div>
      <div class="citybox">
        <p class="city-curr">当前城市： <b>{{storage.get('city').city}}</b></p>
        <div class="citylist" @click="showCityResult=false">
          <div :key="indexs" v-for="(items,indexs) in cityItems">
            <div class="tag" :id="items.letter">{{items.letter}}</div>
            <p :key="index" v-for="(item,index) in items.data" @click="changeCity(item)">{{item.city}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import Service from '@/components/public/Service'
import pinyin from '../../store/pinyin.js';
import domain from '../../store/domain.js';
export default {
  name: 'IndexTop',
  inject:['reload'],
  components: {
    swiper,
    swiperSlide,
  },
  data () {
    return {
      cityItems:this.storage.get('cityItems'),
      bannerList:[],
      swiperOption: {
        autoplay:{
          delay: 5000
        },
        speed: 200,
        lazy:true
      },
      showCity:false,
      cityKey:'',
      showCityResult:false,
      searchCityList:[],
      showTips:false,
    }
  },
  mounted(){
    this.getBanner();
    this.sortCity();
  },
  methods:{
    getBanner(){
      this.$http.get('/api/index/getIndexBanner?type=2').then((response)=>{
        this.bannerList = response.data.result.bannerList;
        this.getSignatureShare();
      }).catch((response)=>{
        console.log(response)
      })
    },
    cityKeyChange(){
      this.searchCityList=[];
      if(this.cityKey!=''){
        this.searchCityList=pinyin.searchResult(this.storage.get('cityItems'),this.cityKey);
        if(this.searchCityList.length==0){
          this.showTips=true
        }else{
          this.showTips=false;
          this.searchCityList.sort(pinyin.sortCity)
        }
        this.showCityResult=true
      }else{
        this.showCityResult=false
      }
    },
    sortCity(){
      var _this = this;
      _this.cityItems=pinyin.pySegSort(_this.cityItems);
    },
    letterClick(id){
      document.querySelector('#citywrap').scrollTop = this.$el.querySelector(id).offsetTop-99;
    },
    changeCity:function(city){
      this.storage.set('city',city);
      domain.change(city.cityCode);
    },
    // 微信获取密钥分享
    getSignatureShare(){
      // var imgUrl = this.bannerList.length>0 ? this.bannerList[0].imageSrc : '';
      // imgUrl = imgUrl.replace(/\s*/g,'');
      var imgUrl = '';
      var shareObj = {
        link: window.location.href,
        title: document.title+'-首页',
        desc: document.title,
        imgUrl: imgUrl,
        logoIndex: this.$store.state.domainIndex
      };
      this.$http.get('/api/wechat/getSignatureInfo?url='+shareObj.link).then((response)=>{
        if(response && response.data.result){
          this.share.weixinShare(shareObj, response.data.result);
        }
      }).catch((response)=>{
        console.log(response)
      })
    },
  }
}
</script>

<style scoped lang="less">
.indextop{position:relative;}
.banner{width:100%;display:block;object-fit:cover;object-position:90% 0%;}
.bannerlist{height:210px;}
.bannerlist img{display:block;width:100%;height:100%;object-fit:cover;}

.searchbox{position:absolute;z-index:1;left:15px;top:10px;right:15px;background:rgba(255,255,255,0.8);height:18px;line-height:18px;border-radius:20px;/*box-shadow:0 1px 5px rgba(0,0,0,0.1);*/padding:9px 90px 8px 40px;}
.mi-search{position:absolute;left:16px;top:9px;background-position:0 0;width:17px;height:17px;}
.sinput{display:block;width:100%;height:100%;font-size:14px;background:none;}
.slocal{position:absolute;right:15px;top:9px;}
.slocal:before{content:"";position:absolute;left:-10px;top:-2px;bottom:-2px;border-left:1px solid #999;}
.mi-sltcity{background-position:-32px 0;margin-right:4px;width:12px;height:15px;}
.el-dropdown-menu{width:372px;left:auto!important;right:15px;padding:10px;box-sizing:border-box;}
.el-dropdown-menu__item{display:inline-block;width:70px;padding:0;text-align:center;}
.navbox{background:#fff;padding:10px;}
.navbox ul{display:table;width:100%;text-align:center;}
.navbox li{display:table-cell;line-height:24px;}
.navbox li .m-icon{display:block;margin:0 auto;width:44px;height:44px;}
.m-icon.new,.m-icon.discount{position:relative;}
.m-icon.new:before,.m-icon.discount:before{content:'';position:absolute;top:-5px;left:28px;height:14px;background:url(../../assets/images/icons.png) no-repeat;background-size:225px;}
.m-icon.new:before{width:14px;background-position:-155px 0;}
.m-icon.discount:before{width:26px;background-position:-170px 0;}
.mi-qblp{background-position:0 -34px;}
.mi-zslp{background-position:-90px -34px;}
.mi-bwzf{background-position:-45px -34px;}
.mi-fdjs{background-position:-135px -34px;}


  .citywrap{position:fixed;top:0;left:0;right:0;bottom:0;background:#fff;z-index:9;overflow:auto;
    .closeicon{float:right;font-size:24px;color:#888;margin-right:15px;font-weight:400;}
    .title{font-size:16px;color:#444;padding-left:15px;line-height:50px;font-weight:700;background:#fff;position:fixed;left:0;right:0;top:0;z-index:1;box-shadow:0 1px 3px rgba(0,0,0,0.2)}
    .initials{position:fixed;right:0;top:50%;text-align:center;z-index:1;
      span{display:block;line-height:22px;font-size:12px;color:#333;width:40px;text-align:center;}
    }
    .citybox{padding-top:90px;position:relative;
      .city-curr{padding:15px;color:#888;
        b{color:#555;}
      }
    }
    .citylist{
      p{display:inline-block;line-height:25px;color:#555;width:30%;text-align:center;margin-bottom:10px;}
      // p+p{border-top:1px solid #f1f2f3;}
      .tag{font-size:12px;color:#888;line-height:25px;padding:0 15px;background:#f2f2f2;margin-bottom:10px;}
    }
    .search-city{position:fixed;left:0;top:50px;right:0;background:#fff;z-index:2;padding:0 15px 10px;
      input{line-height:38px;height:40px;border:0;display:block;width:100%;border:1px solid rgba(0,0,0,0.1);font-size:15px;padding:0 15px 0 45px;box-sizing:border-box;border-radius:20px;}
      .mi-search{left:32px!important;top:11px!important;}
      .search-list{position:absolute;left:15px;right:15px;top:45px;background:#fff;padding:10px 15px;z-index:9;box-shadow:0 1px 3px rgba(0,0,0,0.2);max-height:340px;overflow:auto;
        p,span{display:block;line-height:34px;}
        span{color:#999;text-align:center;}
      }
    }
  }

@media (max-width:768px){
  .navbox{box-shadow:0 1px 2px rgba(0,0,0,0.02)}
  // .banner{height:300px;}
}
@media (max-width:640px){
  // .banner{height:260px;}
}
@media (max-width:540px){
  // .banner{height:200px;}
}
@media (max-width:420px){
  // .banner{height:180px;}
  .el-dropdown-menu{right:5%;width:90%;}
  .el-dropdown-menu__item{width:25%;}
}
</style>



// WEBPACK FOOTER //
// src/components/public/IndexTop.vue